// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Eg","image":"Fg","imageNoBackground":"Gg"};